import React from 'react';
import { twMerge } from 'tailwind-merge';
export const inputClasses = 'w-full rounded-control border bg-surface px-3 text-sm text-ink placeholder:text-ink-soft transition-[border-color,box-shadow] duration-150 ease-snap focus:outline-none focus:border-brand focus:ring-2 focus:ring-brand/20 disabled:bg-canvas disabled:text-ink-soft';
interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}
export function TextInput({
  invalid,
  className,
  ...rest
}: TextInputProps) {
  return <input className={twMerge(inputClasses, 'h-10', invalid ? 'border-critical-border' : 'border-line-strong', className)} aria-invalid={invalid || undefined} {...rest} data-id="element-449" data-mp="3i2zohmcoqni2" />;
}